import firebase from 'firebase'
import 'firebase/firestore'

const withGmailLogin = true;
const is1surguuli = true;
const config =  

is1surguuli?{
  apiKey: "AIzaSyDFz0BxTzEa9iRKym6k5B5SUWTrntelB5w",
  authDomain: "surguuli-91016.firebaseapp.com",
  databaseURL: "https://surguuli-91016.firebaseio.com",
  projectId: "surguuli-91016",
  storageBucket: "surguuli-91016.appspot.com",
  messagingSenderId: "65097765964",
  appId: "1:65097765964:web:3eff15dffd2fbcf3ae10e9",
  measurementId: "G-PJQ9K4L273"
}:
{
    apiKey: "AIzaSyBQZQVZ5z6EI9zUaExh_pTpc6tPMbk_wu4",
    authDomain: "bagsh-c46ce.firebaseapp.com",
    databaseURL: "https://bagsh-c46ce.firebaseio.com",
    projectId: "bagsh-c46ce",
    storageBucket: "bagsh-c46ce.appspot.com",
    messagingSenderId: "480289675702",
    appId: "1:480289675702:web:945ce3b4f8d991ee720917",
    measurementId: "G-2C8RD8T3NS"
  };
firebase.initializeApp(config)
// firebase utils
const realdb = firebase.database()
const firestore=firebase.firestore
const db = firebase.firestore()
const auth = firebase.auth()
 

const currentUser = auth.currentUser
const googleProvider = new firebase.auth.GoogleAuthProvider();
googleProvider.addScope("email");
const usersCollection= db.collection("users")
const storage = firebase.storage;
const storageRef = firebase.storage().ref();

const APPNAME = is1surguuli? "1-Р СУРГУУЛЬ" : "Digital school";
const SHOWLOGO = false;
const LOGOPATH=is1surguuli? "/assets/img/logo.png" : null;
const SCHOOL_TYPE=1; // IF 1 IS this is a secondary school, if it is 2, ids

export {
    db,
    realdb,
    auth,
    currentUser,
    googleProvider, 
    usersCollection,
    storage,
    storageRef,
    firestore,
    APPNAME,
    SHOWLOGO,
    LOGOPATH,
    SCHOOL_TYPE,
    withGmailLogin

}